import SVDropdown from '@pkgs/shared-client/components/SVDropdown';
import SVDropdownContent from '@pkgs/shared-client/components/SVDropdownContent';
import SVIconButton from '@pkgs/shared-client/components/SVIconButton';
import IconSortSVG from '@pkgs/shared-client/img/icon-sort-inlined.svg';

const SVSortDropdownContent = <T extends string>({
	methods,
	sortMethod,
	setSortMethod,
}: {
	methods: Array<{
		name: T;
		label: string;
	}>;
	sortMethod: T;
	setSortMethod: (sortMethod: T) => void;
}) => {
	return (
		<SVDropdown
			triggerType={SVDropdown.TRIGGER_TYPES.CLICK}
			contentOffset="h-3"
			renderTrigger={({ ref, isOpen: _ }) => (
				<SVIconButton src={IconSortSVG} iconClassName="text-gray-400" ref={ref} />
			)}
			renderContent={() => (
				<SVDropdownContent.Links>
					<SVDropdownContent.Links.ItemLabel>Sort by</SVDropdownContent.Links.ItemLabel>
					{methods.map((sortMethodInfo) => (
						<SVDropdownContent.Links.Item
							isSelected={sortMethod === sortMethodInfo.name}
							key={sortMethodInfo.name}
							onClick={() => setSortMethod(sortMethodInfo.name)}
							className="min-w-[150px] px-2.5"
						>
							<span className="ml-2">{sortMethodInfo.label}</span>
						</SVDropdownContent.Links.Item>
					))}
				</SVDropdownContent.Links>
			)}
		/>
	);
};

export default SVSortDropdownContent;
